import { useUser } from '@lore/auth';
import useQuery from '../../people-partners/useQuery';

export default function useNearbyPartners(props) {
  const currentUser = useUser();

  return useQuery({
    search: {
      locationCondition: JSON.stringify({
        address: currentUser.data.zipCode,
        latitude: currentUser.data.latitude,
        longitude: currentUser.data.longitude,
        radius: 50
      })
    }
  });
}
